/* HeyBear · Product "Meet the rest of the bears": cards for every other flavour product. */
HB.section('product-others', function (root) {
  var box = root.querySelector('#others'), go = box.getAttribute('data-go') || 'View flavour';
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var click = function (e) {
    var a = e.target.closest('.oc'); if (!a || e.metaKey || e.ctrlKey) return;
    e.preventDefault(); HB.pdp.go(a.getAttribute('data-f'));
    window.scrollTo({ top: 0, behavior: HB.reduce ? 'auto' : 'smooth' });
  };
  box.addEventListener('click', click);
  var current = '';
  var render = function (k) {
    current = k || current;
    box.innerHTML = HB.data().flavours.filter(function (x) { return x.key !== k; }).map(function (x) {
      var ready = (x.variants || []).some(function (variant) { return variant && variant.id && variant.available === true && variant.price != null; });
      return '<a class="oc' + (ready ? '' : ' is-sold-out') + '" href="' + esc(x.url && !x.demo ? x.url : '#' + x.k3) + '" data-f="' + x.key + '" style="--oc:' + x.bg + '"><img src="' + x.pack + '" alt=""><b><i>' + esc(x.name) + '</i></b><small>' + esc(x.line) + '</small><span class="go">' + esc(ready ? go : 'Get notified') + '</span></a>';
    }).join('');
  };
  var un = HB.pdp.on(render);
  var updated = function () { render(current); };
  document.addEventListener('hb:catalog:updated', updated);
  return function () { un(); box.removeEventListener('click', click); document.removeEventListener('hb:catalog:updated', updated); };
});
